import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Customers } from '@grandvisionhq/api-client';
import { Selectors, State, getToken } from '@grandvisionhq/auth';
import { useSelector, useApiConfig } from '@grandvisionhq/state';

function useGetPrescriptionSignatures() {
    const auth = useSelector(Selectors.getAuth);
    const { apiUrl  } = useApiConfig();
    const isLoggedIn = State.isLoggedIn(auth);
    const [prescriptionSignatures, setPrescriptionSignatures] = React.useState(undefined);
    if (!isLoggedIn) {
        throw new Error(`User needs to be logged in to fetch signed prescriptions`);
    }
    React.useEffect(()=>{
        swcHelpers.asyncToGenerator(function*() {
            try {
                const accessToken = yield getToken();
                const { prescriptionTokens  } = yield Customers.Prescriptions.signedPrescriptions(apiUrl, accessToken, {
                    customerId: auth.userId
                });
                if (prescriptionTokens) {
                    setPrescriptionSignatures(JSON.stringify(prescriptionTokens));
                }
            } catch (err) {
                throw new Error(`Failed to fetch signed prescriptions: ${err}`);
            }
        })();
    }, [
        apiUrl,
        auth.userId
    ]);
    return {
        prescriptionSignatures
    };
}

export { useGetPrescriptionSignatures };
//# sourceMappingURL=use-get-prescription-signatures.js.map
